import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { AgencyRequiredDocumentModel } from "src/app/Model/AgencyRequiredDocument.model";
import { ConnectionTypeDocumentViewModel } from "src/app/Model/ConnectionTypeDocumentView.model";
import { RequestModel } from "src/app/Model/Request.model";
import { RequestStatusProcess } from "src/app/Model/RequestStatusProcess";
import { StatusChangeByComponentView } from "src/app/Model/StatusChangeByComponentView.model";
import { VStatusDocumentUpdated } from "src/app/Model/VStatusDocumentUpdated";
import { SessionStorageService } from "src/app/Services/sessionStorageService/session-storage.service";
import { RequesStatusService } from "src/app/Services/RequestStatus/RequesStatus.service";
import { ComService } from "src/app/Services/com-service/com.service";
import { DocumentService } from "src/app/Services/document/Documentservice";
import Swal from "sweetalert2";
import { ConsultConnectionDocumentsComponent } from "../consult-connection-documents/consult-connection-documents.component";
import { MainComponent } from "../main/main.component";
import { EthicsComplianceService } from "src/app/Services/EthicsCompliance/ethics-compliance.service";
import { RequestService } from "src/app/Services/request/request.service";
import { FormSectionsService } from "src/app/Services/FormSections/form-sections.service";
import { Sections } from "src/app/Model/Enums/Sections.enum";
import { Flows } from "src/app/Model/Enums/Flow.enums";


@Component({
  selector: "app-document",
  templateUrl: "./document.component.html",
  styleUrls: ["./document.component.css"],
})
export class DocumentComponent implements OnInit {
  public formDocuments: FormGroup;
  public ConnectionTypeDocuments: ConnectionTypeDocumentViewModel[] = [];
  public ConnectionTypeDocumentsProces: ConnectionTypeDocumentViewModel[];
  public Request: RequestModel;
  public AgencyUploadedDocuments: AgencyRequiredDocumentModel[];
  public AgencyRequiredDocument: AgencyRequiredDocumentModel;
  public idconnectiontype: string;
  public requestcode: string;
  public searchRadicateBool: boolean;
  public editBool: boolean;
  public deleteBool: boolean;
  public downloadBool: boolean;
  public redirectBool: boolean;
  public completedocument: boolean = true;
  public requiredDocumentsIncomplete: boolean = true;
  public RequestIsInRevision: boolean = true;
  public blobService;
  public Update: any;
  public formSearch: FormGroup;
  public updatedDocumentStatus: VStatusDocumentUpdated[];
  public MainComponent: MainComponent;
  public MasterContainer: string = 'agency-documents';
  public Isrejected: boolean
  public language: string = this.lsService.getLSItem('language')
  public legalRepresentativeDocuments: boolean = false;
  public enableUploadButtons: boolean;
  public Flows = Flows;

  @ViewChild('popUp', { static: false })
  popUp: ElementRef;

  formOne = new FormGroup({
    check: new FormControl('',
      [Validators.required]),
  });

  constructor(
    private readonly _builder: FormBuilder,
    public dialog: MatDialog,
    private readonly Service: DocumentService,
    private readonly requestService: RequestService,
    private readonly activeRoute: ActivatedRoute,
    private readonly translate: TranslateService,
    private readonly modalService: NgbModal,
    private readonly dataService: ComService,
    private readonly RequesStatus: RequesStatusService,
    private readonly SpinnerService: NgxSpinnerService,
    private readonly lsService : SessionStorageService,
    private readonly ethicsComplianceService: EthicsComplianceService,
    private readonly formSectionService: FormSectionsService
  ) {}

  get check() { return this.formOne.get('check'); }
  ngOnInit(): void {
    this.dataService.notifyAboutChange();

    this.formSearch = this._builder.group({
      Search: ["", [Validators.required]],
    });

    if (this.activeRoute.snapshot.params.requestcode == undefined) {
      this.requestcode = this.lsService.getLSItem("RequestCode");
    } else {
      this.requestcode = this.activeRoute.snapshot.params.requestcode;
    }

    this.GetRequestByCode(false);
  }

  /**
   * redirect
   */
  public redirect() {
    let radicate = this.formSearch.get("Search").value;

    if (radicate) {
      window.location.replace(`Register/Main/Document/${radicate}`);
    } else {
      Swal.fire({
        icon: "error",
        title: this.translate.instant("Document.Messages.1"),
        showConfirmButton: false,
        timer: 3000,
      });
    }
  }

  /**
   * redirectAgencyHome
   */
  public redirectAgencyHome() {
    window.location.replace(`Register/Main`);
  }

  /**
   * redirectAgencyHome
   */
  public redirectMyMesajes() {
    window.location.replace(`Register/Main/My-Mesages`);
  }

  public redirectApplicationApproval() {
    window.location.replace(`Register/Main/ApplicationApproval`);
  }

  /**
   * DownloadFormat
   */
  public DownloadFormat(url) {
    let link = document.createElement("a");
    link.download = "name";
    link.href = url;
    link.click();
  }

  openModalConsultConnectionDocuments() {
    const modalRef = this.modalService.open(ConsultConnectionDocumentsComponent, { size: 'xl' });
    modalRef.componentInstance.type = this.Request.ConnectionType
  }

  openDialog(docfolder: string, IdConnectionTypeDocument, Update, Document) {
    const dialogRef = this.dialog.open(DocumentDialogComponent, {
      width: "600px",
      data: {
        CodeRequest: this.requestcode,
        Docfolder: docfolder,
        Request: this.Request,
        IdConnectionTypeDocument: IdConnectionTypeDocument,
        Update: Update,
        Document: Document,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      let doc = this.updatedDocumentStatus.find(x => x.IdAgencyDocument == IdConnectionTypeDocument)
      if ((result != undefined && result != "")) {
        if(this.Request.IdFlow == Flows.Primeringreso && Update)
          this.enableUploadButtons = false
        if (doc != undefined && doc.ReviewDocument == undefined) {
          this.ngOnInit();
        }
        else {
          this.GetRequestByCode(true);
        }
      }
    });
  }

  ConsultDocuments(
  ) {
    const dialogRef = this.dialog.open(ConsultDocumentDialogComponent, {
      width: "900px",
      data: { CodeRequest: this.requestcode, Idrequest: this.Request.Id },
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (result != undefined && result != "") {
        this.GetRequestByCode(true);
      }
    });
  }



  public async GetRequestByCode(noMesaje) {
    this.SpinnerService.show()
    if (this.requestcode != undefined) {
      await this.requestService.getRequestByCode(this.requestcode).then(
        async (res) => {
          this.Request = res;

          //validar si el radicado completó todas las secciones del formulario
          let validateRequest = await this.validateRequest()
          this.SpinnerService.hide()

          if(this.Request.IdFlow == Flows.Primeringreso){
            if(this.Request.LegalRepresentative[0].BirthDate != undefined){
              this.legalRepresentativeDocuments = true
            }
            else
              this.enableUploadButtons = true
          }

          if (!validateRequest) {
            Swal.fire({
              icon: "error",
              title: this.translate.instant("Main.Request"),
              showConfirmButton: false,
              showCloseButton: true,
              timer: 3000,
            }).then((res) => {
              window.location.replace(`Register/Main/Request`);
            })
            
          }
          else {
            sessionStorage.setItem('RequestCode', this.Request.RequestCode)
            sessionStorage.setItem('IdRequest', this.Request.Id.toString())
            sessionStorage.setItem('type', this.Request.ConnectionType.toString())

            if (this.Request == undefined) {
              if (!noMesaje) {
                Swal.fire({
                  icon: "error",
                  title: this.translate.instant("Document.Messages.2"),
                  showConfirmButton: false,
                  timer: 3000,
                });
              }

              this.redirectBool = true;
            } else {
              if (this.Request.RequestIdentification.length != 0) {
                if (!noMesaje) {
                  this.redirectBool = false;
                }
              } else {
                if (!noMesaje) {
                  Swal.fire({
                    icon: "error",
                    title: this.translate.instant("Document.Messages.7"),
                    showConfirmButton: false,
                    timer: 3000,
                  });
                }

                this.redirectBool = true;
              }
            }

            if (!this.redirectBool) {

              let value = this.Request.RequestStatus != undefined
                ? this.Request.RequestStatusNavigation.Id
                : undefined

              if ((value >= 5 || value == 3 || value == 2) && value != 8) {
                this.RequestIsInRevision = true
                if(this.Request.IdFlow == Flows.Primeringreso)
                  this.check.setValue(this.Request.LegalRepresentative[0].AttachDocumentsCheckBoxResponse)
              }
              else {
                this.RequestIsInRevision = false
              }

              if (!this.RequestIsInRevision) {
                await this.GetConnectionTypeDocuments(this.Request, false, noMesaje);
              } else {

                await this.GetConnectionTypeDocuments(this.Request, true, noMesaje);
              }
            }
          }
        }
      );
    } else {
      Swal.fire({
        icon: "error",
        title: this.translate.instant('Document.Messages.5'),
        showConfirmButton: false,
        timer: 3000,
      });

      this.redirectBool = true;
    }

  }
  public async GetConnectionTypeDocuments(request: RequestModel, revised, noMesaje) {

    //Traer todos los documentos que la agencia debe subir
    await this.Service.getGetConnectionDocumentByIdConectionView(
      request
    ).then((res) => {
      if (res != undefined) {
        this.GetDocumentsbyRequest(res, revised, noMesaje);
      } else {
        Swal.fire({
          icon: "error",
          title: this.translate.instant("Document.Messages.6"),
          showConfirmButton: false,
          timer: 3000,
        });

        this.redirectBool = true;
      }
    });
  }

  public async GetDocumentsbyRequest(AgencyRequiredDocuments: ConnectionTypeDocumentViewModel[],revised,noMesaje) {
    this.ConnectionTypeDocuments = [];
    this.searchRadicateBool = false;

    //traer el estado de los documentos
    await this.Service.GetStatusDocumentUpdatedByIdRequest(this.Request.Id).then(async (resp) => {
      this.updatedDocumentStatus = resp
    })

    //traer los documentos que subió la agencia
    await this.Service.getViewDocumentsbyRequest(this.requestcode).then(async (res) => {
      this.AgencyUploadedDocuments = res;
      //Validar si los documentos subidos por la AGY no son iguales a los documentos solicitados, no se deja continuar
      if (this.AgencyUploadedDocuments.length < AgencyRequiredDocuments.length)
        this.requiredDocumentsIncomplete = true
      else
        this.requiredDocumentsIncomplete = false

      this.completedocument = true;
      let ModifyDocuments;
      let rejected = await this.RequesStatus.checkIfRequestIsRejected(this.Request.Id)
    
      //revisa el estado de cada documento cargado para mostrarlo en la lista
      AgencyRequiredDocuments.forEach((element) => {
        let found = this.AgencyUploadedDocuments.find((x) => x.IdConnectionTypeDocument == element.Id);
        //Si el documento requerido fue encontrado en los documentos subidos por la agencia, 
        if (found != undefined) {
          //se activa el botón de consultar documentos 
          this.searchRadicateBool = true;

          element.FileName = found.FileName;
          element.AgencyRequiredId = found.Id;

          let isMessage = found.DocumentStatus;
          //validar si la solicitud se encuentra en revisión en Admin y si ya fue aprobado o rechazado
          if (revised && isMessage == false) {
            //No se muestra ninguno de los botones de acción
            element.deleteBool = false;
            element.editBool = false;
            element.searchBool = false;
            element.downloadBool = false;
          } else {
            //Si el documento fue cargado pero fue solicitada una corrección
            if (found.ReviewDocument != true) {
              element.deleteBool = true;
              element.editBool = true;
              element.searchBool = false;
              element.downloadBool = false;

              if(this.Request.IdFlow == Flows.Primeringreso)
                this.enableUploadButtons = true
              ModifyDocuments = true
            }
            //Si la solicitud está en revisión y se cargo otro archivo debido a corrección 
            else {
              element.deleteBool = false;
              element.editBool = false;
              element.searchBool = false;
              element.downloadBool = false;
            }

          }

          this.ConnectionTypeDocuments.push(element);
        }

        else {

          this.completedocument = false;
          if (revised) {

            if (this.updatedDocumentStatus.find(x => x.IdAgencyDocument == element.Id).Approve == undefined) {
              element.deleteBool = false;
              element.editBool = true;
              element.searchBool = false;
              element.downloadBool = false;

              ModifyDocuments = true

            } else {
              element.deleteBool = false;
              element.editBool = false;
              element.searchBool = false;
              element.downloadBool = false;
            }

          } else {
            //La solicitud no ha subido el archivo y no la solicitud no se ha enviado a revisión
            element.deleteBool = false;
            element.editBool = false;
            element.searchBool = true;
            element.downloadBool = true;

            ModifyDocuments = true
          }

          this.ConnectionTypeDocuments.push(element);
        }
      });
      
      if (ModifyDocuments != true && noMesaje == false) {

        if (AgencyRequiredDocuments.length == 0 && !rejected) {
          this.completedocument = (this.Request.RequestStatus != undefined && this.Request.RequestStatus != 8) ? true : false;
          if ((this.Request.IdFlow == 3 || this.Request.IdFlow == 11 || this.Request.IdFlow == 12) && !this.completedocument) {
            Swal.fire({
              icon: "warning",
              title: this.translate.instant("Document.Messages.14"),
              showConfirmButton: false,
              timer: 3000,
            });
          }
          else{
            Swal.fire({
              icon: "warning",
              title: this.translate.instant("Document.Messages.11"),
              showConfirmButton: false,
              timer: 3000,
            });
          }

        }
        else if(!rejected){
          Swal.fire({
            icon: "warning",
            title: this.translate.instant("Document.Messages.4"),
            showConfirmButton: false,
            timer: 3000,
          });
        }
        else{
          Swal.fire({
            icon: "error",
            title: this.translate.instant("Document.Messages.15"),
            showConfirmButton: false,
            timer: 3000,
          });
        }

      }

    });
  }

  CheckDocumentStatus(id: number) {
    let doc = this.updatedDocumentStatus.find(x => x.IdAgencyDocument == id)
    return doc != null && doc.Approve != true && doc.ReviewDocument != true
  }

  async delete(container, blobName, AgencyRequiredId) {

    this.AgencyRequiredDocument = new AgencyRequiredDocumentModel();
    this.AgencyRequiredDocument.Id = AgencyRequiredId;

    Swal.fire({
      title: this.translate.instant("Document.Messages.Sure"),
      text: this.translate.instant("Document.Messages.Inactivate"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: this.translate.instant("Document.Messages.Cancel"),
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: this.translate.instant("Document.Messages.Confirm"),
    }).then(async (result) => {
      if (result.value) {
        await this.Service.deleteDocument(this.AgencyRequiredDocument).then(
          (res) => {
            this.AgencyRequiredDocument = res;

            this.GetRequestByCode(true);

            Swal.fire({
              icon: "success",
              title: this.translate.instant('Document.Messages.DeleteSuccess'),
              showConfirmButton: false,
              timer: 3000,
            });
            this.requiredDocumentsIncomplete = true;
          }
        );
      }
    });
  }

  /**
   * CompleteDocument
   */
  public async CompleteDocuments(request: RequestModel) {

    Swal.fire({
      title: this.translate.instant("Document.Messages.Sure"),
      text: this.translate.instant("Document.Messages.Inactivate"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: this.translate.instant("Document.Messages.Cancel"),
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: this.translate.instant("Document.Messages.Confirm"),
    }).then(async (result) => {
      if (result.value) {
        await this.Service.CompleteDocument(request).then(async (res) => {
          let StateChange = new RequestStatusProcess();
          StateChange.Approve = true;
          StateChange.IdRequest = request.Id;

          let StateChange2 = new StatusChangeByComponentView();
          StateChange2.Approve = true;
          StateChange2.IdRequest = request.Id;
          StateChange2.IdComponent = 1;

          if(this.Request.IdFlow == Flows.Primeringreso){
            this.Request.LegalRepresentative[0].AttachDocumentsCheckBoxResponse = this.check.value
            await this.requestService.postLegalRepresentativeCheckboxRepsonse(this.Request.LegalRepresentative[0])
          }

          this.SpinnerService.hide();
          const resp = await this.RequesStatus.SetStatusByComponent(StateChange2)

          if(resp.head.status.toLowerCase() != 'true'){
            await Swal.fire({
              title: 'Error!',
              text: this.translate.instant('Request.Messages.ErrorSaving'),
              icon: 'error'
            })
           }
          request = res;

          this.GetRequestByCode(true);

          Swal.fire({
            html: this.popUp.nativeElement,
            width: 400,
            showCloseButton: true,
            confirmButtonText: this.translate.instant('Document.Label.Continue'),
            customClass: {
              confirmButton: 'btn btn-dark',
            },
            buttonsStyling: false
          }).then(async () => {
            this.dataService.notifyAboutChange();
            this.redirectApplicationApproval()
          });

        });
      }
    });
  }


  /**
   * CompleteDocument
   */
  public async CompleteDocumentsEmpty(request: RequestModel) {

    await this.Service.CompleteDocument(request).then(async (res) => {
      let StateChange = new RequestStatusProcess();
      StateChange.Approve = true;
      StateChange.IdRequest = request.Id;

      let StateChange2 = new StatusChangeByComponentView();
      StateChange2.Approve = true;
      StateChange2.IdRequest = request.Id;
      StateChange2.IdComponent = 1;

      this.SpinnerService.hide();

      const resp = await this.RequesStatus.SetStatusByComponent(StateChange2)

      if(resp.head.status.toLowerCase() != 'true'){
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Request.Messages.ErrorSaving'),
          icon: 'error'
        })
       }
      request = res;

      this.GetRequestByCode(true);

      Swal.fire({
        html: this.popUp.nativeElement,
        width: 400,
        showCloseButton: true,
        confirmButtonText: this.translate.instant('Document.Label.Continue'),
        customClass: {
          confirmButton: 'btn btn-dark',
        },
        buttonsStyling: false
      }).then(async () => {
        this.dataService.notifyAboutChange();
        this.redirectApplicationApproval()
      });

    });
  }

  public async validateRequest():Promise<boolean> {

    let validAccessLetterBool = await this.validateAccessLetter()
    let validEthicsBool = await this.validateEthicsCompliance()
    let validSections: boolean[] = []
    let forms = await this.formSectionService.get(this.Request.IdFlow)
    forms = forms.sort((a,b) => a.Order - b.Order)
    forms.forEach(section => {
      if(section.IdComponent == Sections.Generalidades){
        validSections.push(this.Request.completeOverview())
      }
      else if(section.IdComponent == Sections.Localizacion){
        validSections.push(this.Request.completeLocation())
      }
      else if(section.IdComponent == Sections.Identicacion){
        validSections.push(this.Request.completeIdentification())
      }
      else if(section.IdComponent == Sections.RepLegal){
        validSections.push(this.Request.completeLegal())
      }
      else if(section.IdComponent == Sections.Accionistas){
        validSections.push(this.Request.completePartners())
      }
      else if(section.IdComponent == Sections.AdminPortal){
        validSections.push(this.Request.completeAdminPortal())
      }
      else if(section.IdComponent == Sections.Firmas){
        validSections.push(this.Request.completeSignatures())
      }
      else if(section.IdComponent == Sections.AccesoInventario){
        let validAccessLetter = validAccessLetterBool
        validSections.push(validAccessLetter)
      }
      else if(section.IdComponent == Sections.Etica){
        let validEthics = validEthicsBool
        validSections.push(validEthics)
      }
    })
    return validSections.every(x => x)
  }

  public async validateEthicsCompliance() {
    let EntityTypeBool: boolean;
    let AviancaPoliciesBool: boolean;
    let PoliticsExposedBool: boolean;
    let ConflictInterestBool: boolean;
    let TermsCoditionsBool: boolean;

    let oldIdBillingPeriod = this.Request.IdBillingPeriod

    this.Request.IdBillingPeriod = 2;
    await this.checkEntityTypeBool(this.Request).then(res => {
      EntityTypeBool = res
    });

    this.Request.IdBillingPeriod = 3;
    await this.checkEntityTypeBool(this.Request).then(res => {
      AviancaPoliciesBool = res
    });

    this.Request.IdBillingPeriod = 4;
    PoliticsExposedBool = await this.checkEntityTypeBool(this.Request)

    this.Request.IdBillingPeriod = 5;
    ConflictInterestBool = await this.checkEntityTypeBool(this.Request)

    this.Request.IdBillingPeriod = 6;
    TermsCoditionsBool = await this.checkEntityTypeBool(this.Request)

    this.Request.IdBillingPeriod = oldIdBillingPeriod

    return EntityTypeBool && AviancaPoliciesBool && PoliticsExposedBool && ConflictInterestBool && TermsCoditionsBool

  }

  public async validateAccessLetter() {
    let AccessLetterBool: boolean;
    let oldIdBillingPeriod = this.Request.IdBillingPeriod

    this.Request.IdBillingPeriod = 7;
    AccessLetterBool = await this.checkEntityTypeBool(this.Request)

    this.Request.IdBillingPeriod = oldIdBillingPeriod

    return AccessLetterBool
  }

  public async checkEntityTypeBool(section: RequestModel) {
    let response: boolean
    if (!Number.isNaN(section.Id)) {
      await this.ethicsComplianceService.getAnswersBySection(section).then(res => {
        if (res.length != 0) {
          response = true
        } else {
          response = false
        }
        return response;
      });
    }
    return response;
  }

  setRlOption(){
    this.enableUploadButtons = this.check.value
    this.Request.LegalRepresentative[0].AttachDocumentsCheckBoxResponse = this.check.value
    if(this.AgencyUploadedDocuments.length > 0 && !this.enableUploadButtons){
      
      //Borrar los documentos subidos para evitar inconsistencias en la data
      this.AgencyUploadedDocuments.forEach(async docs => {
        this.AgencyRequiredDocument = new AgencyRequiredDocumentModel();
        this.AgencyRequiredDocument.Id = docs.Id;
        await this.Service.deleteDocument(this.AgencyRequiredDocument).then(
          (res) => {
            this.AgencyRequiredDocument = res;
            this.requiredDocumentsIncomplete = true;
          }
        );
      })
      this.GetRequestByCode(true);
    }
  }

  showTooltip(tooltipMessage: string){
    return this.enableUploadButtons ? this.translate.instant(tooltipMessage) : ""
  }

  checkSendButton(){
    let disableButton = true
    //Si el radicado debe cargar documentos
    if(this.enableUploadButtons){
      //Si se solicita que se responda el checkbox
      if(this.legalRepresentativeDocuments)
        disableButton = this.requiredDocumentsIncomplete || (this.completedocument && this.RequestIsInRevision) || this.formOne.invalid
      else
        disableButton = this.requiredDocumentsIncomplete || (this.completedocument && this.RequestIsInRevision)
    }
    else{
      disableButton = this.formOne.invalid || this.RequestIsInRevision
    }
    return disableButton
  }
}

@Component({
  selector: "document-dialog",
  templateUrl: "./document-dialog.component.html",
  styleUrls: ["./document.component.css"],
})
export class DocumentDialogComponent {
  public isMobile: boolean = false;
  public repeatedBool: boolean = false;
  public ErrorBool: boolean = false;
  public AgencyRequiredDocument: AgencyRequiredDocumentModel;
  public AgencyRequiredDocuments: AgencyRequiredDocumentModel[];
  public format: string;
  public formatPath: string;

  public formCountry: FormGroup;

  constructor(
    private readonly Service: DocumentService,
    breakpointObserver: BreakpointObserver,
    public dialogRef: MatDialogRef<DocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    breakpointObserver.observe([Breakpoints.Handset]).subscribe((result) => {
      this.isMobile = result.matches;
    });
    this.format = this.data.Document.Extension;
  }

  /**
   * SaveDocument
   */
  public async SaveDocument(event) {

    this.AgencyRequiredDocument = new AgencyRequiredDocumentModel();

    if (this.data.Update != false) {
      this.AgencyRequiredDocument.Id = this.data.Update;
    } else {
      this.AgencyRequiredDocument.Id = 0;
    }

    this.AgencyRequiredDocument.IdRequest = this.data.Request.Id;
    this.AgencyRequiredDocument.RequestCode = this.data.Request.RequestCode;
    this.AgencyRequiredDocument.AgencyNit =
      this.data.Request.RequestIdentification[0].AgencyNumber;
    this.AgencyRequiredDocument.IdConnectionType =
      this.data.Request.ConnectionType;
    this.AgencyRequiredDocument.IdConnectionTypeDocument =
      this.data.IdConnectionTypeDocument;
    this.AgencyRequiredDocument.FileName = event.Name;
    this.AgencyRequiredDocument.FileUrl = event.Url;
    this.AgencyRequiredDocument.StateWallet = "false";
    this.AgencyRequiredDocument.StateProduct = "false";

    await this.Service.postDocument(this.AgencyRequiredDocument).then((res) => {
      this.AgencyRequiredDocument = res;
    });

    this.dialogRef.close(this.data);
  }
}

/**
 * CONSULTING DIALOG
 */

@Component({
  selector: "consult-document-dialog",
  templateUrl: "./consult-document-dialog.component.html",
  styleUrls: ["./document.component.css"],
})
export class ConsultDocumentDialogComponent {
  public isMobile: boolean = false;
  public repeatedBool: boolean = false;
  public ErrorBool: boolean = false;
  public AgencyRequiredDocument: AgencyRequiredDocumentModel;
  public AgencyRequiredDocuments: AgencyRequiredDocumentModel[];
  public format: string;

  public formCountry: FormGroup;

  constructor(
    breakpointObserver: BreakpointObserver,
    public dialogRef: MatDialogRef<DocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    breakpointObserver.observe([Breakpoints.Handset]).subscribe((result) => {
      this.isMobile = result.matches;
    });
  }
}
